import { MagicConfigMixin, SessionChange } from '@gig/magic-common';
import { Mixins, Emit, Component } from 'vue-property-decorator';
import { magic, CtaStyle } from '@gig/magic-sdk';
import { store } from '../store/index.js';
import { UserRolesUpdated } from '@gig/magic-common/dist/util/helpers/user';

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
let PromotionsOptinMixin = class extends Mixins(MagicConfigMixin) {
  constructor() {
    super(...arguments);
    this.isOptingIn = false;
    this.userRoles = [];
    this.isLoggedIn = false;
    this.optInPromoName = "";
    this.optInCta = null;
    this.shouldResumeOptIn = false;
  }
  syncUserRoles(ev) {
    if (ev.roles) {
      const roles = ev.roles.map((role) => role.name);
      this.userRoles = roles;
    }
  }
  onSessionChange(isLoggedIn) {
    var _a;
    this.isLoggedIn = isLoggedIn;
    if (isLoggedIn) {
      return this.userRoles = ((_a = magic.session.getUser()) == null ? void 0 : _a.roles) || [];
    }
    this.userRoles = [];
  }
  optIn(promoName, cta) {
    return __async(this, null, function* () {
      const user = magic.session.getUser();
      if (!this.isOptIn(cta) || this.isOptingIn) {
        return;
      }
      if (!user) {
        this.__requireLogin();
        this.shouldResumeOptIn = true;
        this.optInCta = cta;
        this.optInPromoName = promoName;
        return;
      }
      if (!cta.roles) {
        return;
      }
      try {
        this.isOptingIn = true;
        yield magic.methods.promotions.optIn(promoName, this.magicConfig.language, cta.text, user.id);
        this.__handleOptInSuccess();
      } catch (e) {
        this.__handleOptInError(e);
      } finally {
        this.isOptingIn = false;
      }
    });
  }
  isOptIn(cta) {
    return cta.style === CtaStyle.OPTIN;
  }
  resumeOptIn(isLoggedIn) {
    if (this.shouldResumeOptIn && isLoggedIn) {
      this.shouldResumeOptIn = false;
      this.optIn(this.optInPromoName, this.optInCta);
    }
  }
  __requireLogin() {
    return;
  }
  __handleOptInError(error) {
    return error;
  }
  __handleOptInSuccess() {
    return;
  }
};
__decorateClass([
  UserRolesUpdated()
], PromotionsOptinMixin.prototype, "syncUserRoles", 1);
__decorateClass([
  SessionChange({ immediate: true })
], PromotionsOptinMixin.prototype, "onSessionChange", 1);
__decorateClass([
  SessionChange({ immediate: true })
], PromotionsOptinMixin.prototype, "resumeOptIn", 1);
__decorateClass([
  Emit("requireLogin")
], PromotionsOptinMixin.prototype, "__requireLogin", 1);
__decorateClass([
  Emit("optInError")
], PromotionsOptinMixin.prototype, "__handleOptInError", 1);
__decorateClass([
  Emit("optInSuccess")
], PromotionsOptinMixin.prototype, "__handleOptInSuccess", 1);
PromotionsOptinMixin = __decorateClass([
  Component({
    store
  })
], PromotionsOptinMixin);

export { PromotionsOptinMixin };
